
// Koffeinbolaget — shared front-end JS.
// Accordion, drawer nav (drill-down, recently viewed), pack ladder, sticky mobile add-to-cart,
// quickshop no-op, filter bar (presentational).
// The horizontal nav and its mega-menus were replaced by the drawer — Proteinbolaget
// hides its whole catalogue behind one, and at that URL count nothing else fits.
// Dropped from the Snusjakt build: the age gate (caffeine is food, not tobacco) and the
// Thursday-drop countdown (that was an outlet scarcity mechanic, not a retail one).
(function(){
  // ---------- 1. Accordion ----------
  document.querySelectorAll('.acc button').forEach(function(btn){
    btn.addEventListener('click',function(){
      var acc=btn.closest('.acc'), open=acc.getAttribute('data-open')==='true';
      acc.setAttribute('data-open', open?'false':'true');
      btn.setAttribute('aria-expanded', open?'false':'true');
    });
  });

  // ---------- 2. Drawer nav ----------
  // One drawer holds the whole catalogue, Proteinbolaget-style, with drill-down
  // sub-panels. The markup ships on every page; this only handles showing it.
  (function(){
    var drawer=document.getElementById('siteDrawer');
    // querySelectorAll, not querySelector: the header burger is no longer the only
    // trigger. W10's bottom pill reuses the SAME [data-drawer-open] contract for its
    // Kategorier slot rather than shipping a second navigation, so every opener has
    // to bind and every opener has to carry the right aria-expanded.
    var openers=document.querySelectorAll('[data-drawer-open]');
    if(!drawer || !openers.length) return;
    var panel=drawer.querySelector('.drawer-panel');
    var subs=drawer.querySelectorAll('[data-drill-panel]');
    var topLevel=drawer.querySelector('.drawer-body');
    var lastFocus=null;
    var FOCUSABLE='a[href],button:not([disabled]),input';

    function openSubs(){
      var open=null;
      for(var i=0;i<subs.length;i++){ if(subs[i].getAttribute('data-open')==='true') open=subs[i]; }
      return open;
    }
    // The pinned head leads the cycle at every level, because it is visible at every
    // level. Until 2026-09-23 it held only the close button, which was unshifted onto the
    // list by hand. It now holds the logo link as well, BEFORE the close button, and
    // that hand-unshift would have left the logo unreachable: Shift+Tab from close
    // wrapped to the last row before the browser could get there.
    function focusables(){
      var scope=openSubs() || topLevel;
      var head=drawer.querySelector('.drawer-head');
      var list=[].slice.call(head ? head.querySelectorAll(FOCUSABLE) : [])
        .concat([].slice.call((scope?scope:panel).querySelectorAll(FOCUSABLE)));
      var out=[];
      for(var i=0;i<list.length;i++){ if(list[i].offsetParent!==null) out.push(list[i]); }
      return out;
    }
    function expanded(v){
      for(var i=0;i<openers.length;i++){ openers[i].setAttribute('aria-expanded', v); }
    }
    function closeSubs(){
      for(var i=0;i<subs.length;i++){ subs[i].setAttribute('data-open','false'); }
      var trigs=drawer.querySelectorAll('[data-drill]');
      for(var k=0;k<trigs.length;k++){ trigs[k].setAttribute('aria-expanded','false'); }
      // before any caller focuses a trigger again: nothing inside an inert box can take focus
      if(topLevel) topLevel.removeAttribute('inert');
    }
    function open(){
      lastFocus=document.activeElement;
      drawer.setAttribute('data-open','true');
      expanded('true');
      document.body.classList.add('drawer-open');
      // The close button BY NAME, not "the first focusable": since the rebuild the logo
      // link comes first in the head. And never the search field, which would throw the
      // phone keyboard up over the menu that was just opened (trap 4 in the plan).
      var x=drawer.querySelector('.drawer-x');
      if(x) x.focus();
    }
    function close(){
      drawer.setAttribute('data-open','false');
      expanded('false');
      document.body.classList.remove('drawer-open');
      closeSubs();
      if(lastFocus && lastFocus.focus) lastFocus.focus();
    }

    for(var o=0;o<openers.length;o++){
      openers[o].addEventListener('click',function(){
        drawer.getAttribute('data-open')==='true' ? close() : open();
      });
    }
    var closers=drawer.querySelectorAll('[data-drawer-close]');
    for(var c=0;c<closers.length;c++){ closers[c].addEventListener('click',close); }

    var trigs=drawer.querySelectorAll('[data-drill]');
    for(var t=0;t<trigs.length;t++){
      (function(tr){
        tr.addEventListener('click',function(){
          var key=tr.getAttribute('data-drill');
          var sub=drawer.querySelector('[data-drill-panel="'+key+'"]');
          if(!sub) return;
          closeSubs();
          sub.setAttribute('data-open','true');
          tr.setAttribute('aria-expanded','true');
          // The top level stays painted under the panel for the slide, but it leaves the
          // tab order: only the two ends of the cycle are trapped, so Tab from the close
          // button used to walk straight into rows hidden under the open panel (measured
          // 2026-09-23 with this line removed: focus landed on the search field, which
          // the open panel covered). inert takes them out of the accessibility tree as
          // well. closeSubs() lifts it.
          if(topLevel) topLevel.setAttribute('inert','');
          var back=sub.querySelector('[data-drill-back]');
          if(back) back.focus();
        });
      })(trigs[t]);
    }
    var backs=drawer.querySelectorAll('[data-drill-back]');
    for(var b=0;b<backs.length;b++){
      (function(bk){
        bk.addEventListener('click',function(){
          var sub=bk.closest('[data-drill-panel]');
          closeSubs();
          if(sub){
            var tr=drawer.querySelector('[data-drill="'+sub.getAttribute('data-drill-panel')+'"]');
            if(tr) tr.focus();
          }
        });
      })(backs[b]);
    }

    document.addEventListener('keydown',function(e){
      if(drawer.getAttribute('data-open')!=='true') return;
      if(e.key==='Escape' || e.key==='Esc'){
        // Escape steps back one level before it closes the whole thing
        var sub=openSubs();
        if(sub){
          var tr=drawer.querySelector('[data-drill="'+sub.getAttribute('data-drill-panel')+'"]');
          closeSubs();
          if(tr) tr.focus();
        } else { close(); }
        return;
      }
      if(e.key!=='Tab') return;
      var f=focusables();
      if(!f.length) return;
      var first=f[0], last=f[f.length-1];
      // Focus can sit outside the cycle: a click on the trust band, a heading or the
      // scroll area moves it to <body>. Trapping only the two ends would then let Tab
      // walk out into the page behind the scrim, so it re-enters at the matching end.
      if(f.indexOf(document.activeElement)===-1){
        e.preventDefault(); (e.shiftKey ? last : first).focus(); return;
      }
      if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
    });
  })();

  // ---------- 2b. Recently viewed: "Fortsätt där du slutade" ----------
  // The drawer's one per-visitor group, so the one thing in it that is injected rather
  // than server-rendered. Built 2026-09-23 (research/nav-drawer-plan.md section 5).
  //
  // RECORD. On a product page (a /products/{handle} path that renders .pdp) the handle
  // goes first in localStorage['kb:recent']: a JSON array of handles, deduplicated, at
  // most 6. Handles only. No title, price or image is stored, so storage cannot go stale
  // and a price change can never show an old price.
  //
  // RENDER. On the drawer's first open per page load, the first stored handle that is not
  // this page's own product is fetched as /products/{handle}?section_id=kb-recent-card.
  // The Section Rendering API renders sections/kb-recent-card.liquid in THAT product's
  // context, so the card arrives with Liquid's money format, the real mg metafield and
  // the single-tin price, and this file formats nothing. A 404, or an empty response (the
  // section prints nothing for an unavailable product), drops that handle and tries the
  // next one, at most two fetches per open. Any other failure (offline, a 5xx) keeps the
  // history and stops: it says nothing about the product.
  // ⚠️ DO NOT KEY THE DROP ON 404 ALONE. Measured on the dev theme 2026-09-23: a made-up
  // handle answers 200 with an empty 72-byte section wrapper, not 404. The empty card is
  // the signal that always arrives; the 404 branch is there for when one does.
  //
  // ⚠️ EVERY STORAGE ACCESS IS IN try/catch. Private mode and blocked storage throw on
  // access in some browsers; here they are silent no-ops and the group stays hidden.
  // Nothing in this block logs, on purpose: a visitor with no history is not an error.
  // The card is a plain link and nothing binds to it. Section 2 re-collects focusables
  // on every Tab, so an injected card joins the cycle with no extra code (trap 6).
  //
  // CONSENT, since 2026-09-23 (research/cookie-banner-plan.md section 7.3). This list is
  // a preference, not a strict necessity, and it was the theme's only storage write, done on
  // every product visit without asking. write() is now the one door to storage in this block
  // and it opens only while the consent engine (assets/kb-consent.js) reports
  // preferences: true. No engine at all, or no decision yet, writes nothing. The key is
  // removed whenever the answer is anything but yes, "unresolved" and "unavailable"
  // included, so revoking in the footer's Cookieinställningar clears it on the spot.
  // The first decision is read through kbConsent.ready, never the event alone: the engine
  // can publish it before this file runs, and a listener added afterwards would miss it.
  (function(){
    var KEY='kb:recent', MAX=6, TRIES=2;

    function read(){
      try{
        var v=JSON.parse(window.localStorage.getItem(KEY)||'[]');
        return Array.isArray(v) ? v.filter(function(h){ return typeof h==='string' && h; }) : [];
      }catch(e){ return []; }
    }
    function yes(detail){ return !!(detail && detail.preferences===true); }
    function allowed(){
      var c=window.kbConsent;
      return !!(c && typeof c.state==='function' && yes(c.state()));
    }
    function write(list){
      if(!allowed()) return;
      try{ window.localStorage.setItem(KEY, JSON.stringify(list.slice(0,MAX))); }catch(e){}
    }
    function forget(){
      try{ window.localStorage.removeItem(KEY); }catch(e){}
    }

    var here=null;
    var m=window.location.pathname.match(/\/products\/([^\/]+)/);
    if(m && document.querySelector('.pdp')){
      try{ here=decodeURIComponent(m[1]); }catch(e){ here=m[1]; }
    }
    function record(){
      if(here) write([here].concat(read().filter(function(h){ return h!==here; })));
    }
    // A yes given on this very page records this product too, so "Ja, tillåt alla" on the
    // first product a visitor sees does not leave that product out of the list.
    function sync(detail){ if(yes(detail)) record(); else forget(); }
    if(window.kbConsent && window.kbConsent.ready){ window.kbConsent.ready.then(sync); }
    document.addEventListener('kb:consent', function(e){ sync(e.detail); });

    var drawer=document.getElementById('siteDrawer');
    var group=drawer && drawer.querySelector('[data-recent]');
    var slot=group && group.querySelector('[data-recent-slot]');
    if(!slot || !window.fetch || !window.MutationObserver) return;
    // Locale-aware, so an /en/ visitor gets the card in English.
    var root=(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function render(){
      var queue=read().filter(function(h){ return h!==here; }).slice(0,TRIES);
      (function next(){
        var handle=queue.shift();
        if(!handle) return;
        fetch(root+'products/'+encodeURIComponent(handle)+'?section_id=kb-recent-card',
              {credentials:'same-origin'})
          .then(function(r){
            if(r.status===404) return '';
            return r.ok ? r.text() : null;
          })
          .then(function(html){
            if(html===null) return;
            var tpl=document.createElement('template');
            tpl.innerHTML=html;
            var card=tpl.content.querySelector('a.drecent');
            if(!card){
              write(read().filter(function(h){ return h!==handle; }));
              next();
              return;
            }
            var li=document.createElement('li');
            li.appendChild(document.importNode(card,true));
            slot.appendChild(li);
            group.hidden=false;
          })
          .catch(function(){});
      })();
    }

    // First open only, whichever opener did it: watch the drawer's own state rather
    // than the burger, because the tab bar's Kategorier slot opens it too.
    var mo=new MutationObserver(function(){
      if(drawer.getAttribute('data-open')!=='true') return;
      mo.disconnect();
      render();
    });
    mo.observe(drawer,{attributes:true,attributeFilter:['data-open']});
  })();

  // ---------- 3. Pack ladder ----------
  (function(){
    var ladders=document.querySelectorAll('[data-ladder]');
    if(!ladders.length) return;
    ladders.forEach(function(ladder){
      var scope=ladder.closest('.pcard, .pdp, .stickyatc') || ladder;
      var options=ladder.querySelectorAll('[data-pack]');
      options.forEach(function(opt){
        opt.addEventListener('click',function(){
          // selection must be exposed to assistive tech, not just as a colour class
          options.forEach(function(o){ o.classList.remove('on'); o.setAttribute('aria-pressed','false'); });
          opt.classList.add('on'); opt.setAttribute('aria-pressed','true');
          var pack=opt.getAttribute('data-pack');
          var total=opt.getAttribute('data-total');
          var summary=scope.querySelector('[data-pack-summary]');
          if(summary) summary.textContent = pack+'-pack · '+total+' kr';
          var totalEl=scope.querySelector('[data-pack-total]');
          if(totalEl) totalEl.textContent = total+' kr';
          // mirror into the sticky bar ONLY from the PDP's own buy box — a related
          // or recently-viewed card must never rewrite the price next to Fynda nu
          if(scope.classList && scope.classList.contains('pdp')){
            var stickyTotal=document.querySelector('.stickyatc [data-pack-total]');
            if(stickyTotal && stickyTotal!==totalEl) stickyTotal.textContent = total+' kr';
          }
        });
      });
    });
  })();

  // ---------- 4. Sticky mobile add-to-cart ----------
  // Rebuilt 2026-09-22. Two changes, and the first one is the important one.
  //
  // 1. IT MEASURES THE BUTTON, NOT A SENTINEL. This used to observe a 1px
  //    [data-atc-sentinel] div with an IntersectionObserver. That indirection had
  //    already cost one silent failure: the sentinel did not exist at all for a
  //    while, so the block returned early and the bar never appeared. A sentinel was
  //    then added and the bar STILL never appeared in testing. Rather than debug a
  //    proxy for the button, this now asks the button. "Is .pdp-atc off the top of
  //    the screen" is the requirement, stated directly, and it is trivially checkable
  //    from the console: scroll, then read bar.dataset.show.
  //    rAF-throttled and passive, so it costs one rect read per painted frame while
  //    scrolling and nothing at rest.
  //
  // 2. THE BAR CAN BUY. Its button clicks .pdp-atc, so it posts exactly what the
  //    real button posts and inherits its disabled state. Since 2026-09-23 the bar has
  //    NO stepper: the quantity is chosen on the PDP's quantity cards, and the bar only
  //    mirrors that choice. The cards script in sections/main-product.liquid writes the
  //    quantity into .stickyatc [data-sticky-qty] and the total into
  //    .stickyatc [data-pack-total]. This file writes neither, so there is exactly one
  //    writer for each and this bar is a view.
  (function(){
    var bar = document.querySelector('.stickyatc.js-stickyatc');
    var atc = document.querySelector('.pdp-atc');
    if(!bar || !atc) return;

    var mq = window.matchMedia('(max-width:600px)');
    var ticking = false;

    // W10: the ONE place that knows whether the buy bar is on screen, so it is also
    // the one place that publishes it. body[data-atc-visible] is what the bottom pill
    // watches to slide itself out; two fixed bars at ~138px on an 812px screen is an
    // accident, not a design.
    function show(v){
      bar.setAttribute('data-show', v ? 'true' : 'false');
      if(v){ document.body.setAttribute('data-atc-visible','true'); }
      else { document.body.removeAttribute('data-atc-visible'); }
    }
    function measure(){
      ticking = false;
      // 600px, not a new number: v3.css hides .stickyatc above 600 and the trust-bar
      // marquee uses the same boundary. Keep JS and CSS on one line.
      if(!mq.matches){ show(false); return; }
      show(atc.getBoundingClientRect().bottom < 0);
    }
    function schedule(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if(mq.addEventListener){ mq.addEventListener('change', schedule); }
    measure();

    // ---- the bar's one control, a proxy ----
    var addB  = bar.querySelector('[data-sticky-add]');
    // .pdp-atc carries `disabled` when the variant is sold out; clicking a disabled
    // button is a no-op, so the sold-out state needs no separate handling here, but
    // the bar should not invite the press either.
    if(addB){
      addB.addEventListener('click', function(){ atc.click(); });
      if(atc.disabled){ addB.disabled = true; }
    }
  })();

  // ---------- 4b. Bottom tab bar: the Sök slot ----------
  // The other four slots are plain links or the drawer's own [data-drawer-open]
  // contract, so they need no JavaScript at all. Search is the exception: building a
  // second search UI for one slot would fork the predictive-search wiring, so the
  // button borrows the header's field instead: jump to the top, focus the input.
  // Instant scroll, not smooth: the caret must not chase a moving field, and an
  // animation here would need a prefers-reduced-motion branch to earn nothing.
  (function(){
    var btn=document.querySelector('[data-kb-tabbar-search]');
    if(!btn) return;
    btn.addEventListener('click',function(){
      var input=document.querySelector('.hdr .search input[type="search"]');
      window.scrollTo(0,0);
      if(input) input.focus();
    });
  })();

  // ---------- 5. Quickshop no-op ----------
  document.querySelectorAll('.js-quickshop[data-quickshop]').forEach(function(btn){
    var original=btn.textContent;
    var timer=null;
    btn.setAttribute('aria-live','polite');
    btn.addEventListener('click',function(e){
      e.preventDefault(); // no-op: never navigates, never submits
      if(timer){ clearTimeout(timer); } else { original=btn.textContent; }
      btn.textContent='Mockup — ingen kassa';
      timer=setTimeout(function(){
        btn.textContent=original;
        timer=null;
      },1600);
    });
  });

  // ---------- 6. Filter bar (presentational) ----------
  // Deliberately non-functional for the mockup: toggles a pressed state only, no filtering logic.
  // Buttons only. The chips are <a> in both the mockup and the Shopify theme — there they are
  // real facet links driven by Dawn's facets.js, and toggling aria-pressed on a link is both
  // wrong (links are not toggle buttons) and a flash of state right before navigation.
  document.querySelectorAll('.filterbar button.fb-chip').forEach(function(chip){
    chip.addEventListener('click',function(){
      var pressed=chip.getAttribute('aria-pressed')==='true';
      chip.setAttribute('aria-pressed', pressed?'false':'true');
      chip.classList.toggle('on', !pressed);
    });
  });


  // --- Koffeintabellen: search + category filter + sort ---------------------
  // Server-rendered rows, filtered in place. No fetch, no template — the table is the
  // data, so it still reads and ranks with JS off.
  (function(){
    var rows=[].slice.call(document.querySelectorAll('[data-caf-row]'));
    if(!rows.length) return;
    var search=document.querySelector('[data-caf-search]'),
        chips=[].slice.call(document.querySelectorAll('[data-caf-cat]')),
        countEl=document.querySelector('[data-caf-count]'),
        emptyEl=document.querySelector('[data-caf-empty]'),
        sortBtn=document.querySelector('[data-caf-sort]'),
        body=rows[0].parentNode,
        cat='alla', desc=true;

    function apply(){
      var q=(search&&search.value||'').trim().toLowerCase(), shown=0;
      rows.forEach(function(r){
        var ok=(cat==='alla'||r.getAttribute('data-cat')===cat) &&
               (!q||r.getAttribute('data-name').indexOf(q)>-1);
        r.hidden=!ok;
        if(ok) shown++;
      });
      if(countEl) countEl.textContent=shown;
      if(emptyEl) emptyEl.hidden=shown>0;
    }
    function sort(){
      rows.slice().sort(function(a,b){
        var d=(+a.getAttribute('data-mg'))-(+b.getAttribute('data-mg'));
        return desc?-d:d;
      }).forEach(function(r){ body.appendChild(r); });
      if(sortBtn) sortBtn.querySelector('span').textContent=desc?'↓':'↑';
    }
    if(search) search.addEventListener('input',apply);
    chips.forEach(function(c){
      c.addEventListener('click',function(){
        chips.forEach(function(x){ x.classList.remove('on'); });
        c.classList.add('on');
        cat=c.getAttribute('data-caf-cat');
        apply();
      });
    });
    if(sortBtn) sortBtn.addEventListener('click',function(){ desc=!desc; sort(); });
  })();

  /* --------------------------------------------------------------------------
     Sticky header — condensed state + the height other sticky things measure from

     Two jobs, one scroll handler:
       1. body.hdr-condensed past the threshold, which drives the shrink in CSS.
       2. --hdr-h, the header's REAL height. .filterbar sticks at top:var(--hdr-h)
          and below 900px the header is two rows tall, so no constant in the CSS
          could be right at every width. Measuring is the only honest answer.

     Guarded on .hdr-sticky: when the theme setting is off the class is absent,
     nothing binds, and --hdr-h stays unset so .filterbar falls back to top:0.
     -------------------------------------------------------------------------- */
  (function(){
    var sec = document.querySelector('.hdr-sec');
    if(!sec || !document.body.classList.contains('hdr-sticky')) return;

    var THRESHOLD = 120, queued = false;

    function measure(){
      document.body.style.setProperty('--hdr-h', sec.offsetHeight + 'px');
    }
    function update(){
      queued = false;
      var past = (window.pageYOffset || document.documentElement.scrollTop) > THRESHOLD;
      if(past !== document.body.classList.contains('hdr-condensed')){
        document.body.classList.toggle('hdr-condensed', past);
        // the shrink is a 180ms transition; remeasure once it has landed
        setTimeout(measure, 220);
      }
    }
    function onScroll(){
      if(!queued){ queued = true; requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, {passive:true});

    // ⚠️ A window resize listener is NOT enough here. The header's height also
    // changes when the webfont lands, when the cart count gains a digit, and at
    // the 900px break where the search field drops to its own row — and a stale
    // --hdr-h parks the filter bar 50-odd pixels too high, underneath the header.
    // ResizeObserver watches the box itself, so every cause is covered by one hook.
    measure();                                    // never depend on the observer's first tick
    if(window.ResizeObserver){
      new ResizeObserver(measure).observe(sec);
    } else {
      window.addEventListener('resize', measure, {passive:true});
    }
    update();
  })();

  // ---------- 7. Rolling trust bar ----------
  // Two things are measured here, both on the same pass.
  //
  // --roll-duration: the track width divided by px/sec, so the loop speed stays
  // constant regardless of copy length; a fixed duration would make long copy race
  // and short copy crawl. The CSS (kb-roll, theme.css) renders two copies of the
  // track and shifts by translateX(-100%); this only sets how long one shift takes.
  //
  // --roll-gap: the fix for the same trust point appearing twice on one screen.
  // The marquee is two identical tracks side by side, so the moment ONE track is
  // narrower than the viewport, the tail of the first and the head of the second
  // are both in frame and a reader sees "Fri frakt över 399 kr" twice at once.
  // Measured on the QA theme, 2026-09-21: the track is 1161px, which clears a
  // 1024px laptop but falls 279px short at 1440 and 759px short at 1920, so every
  // ordinary desktop showed the repeat while mobile never did.
  //
  // ⚠️ Repeating the copy is NOT the fix, it is the cause: duplicating a track to
  // fill the screen is precisely what puts the same words on screen twice. The
  // invariant is that one pass of UNIQUE copy must be at least a screen wide, and
  // with the copy fixed the only free variable is the space between the items. So
  // the shortfall is divided into the gaps. Track width is sum(items) + (n-1)*gap
  // plus the seam padding that matches it, i.e. sum + n*gap, so the gap that closes
  // a viewport is (viewport - sum) / n. Below that the resting 34px stands.
  //
  // The alternative was to stop rolling on wide screens, which is what
  // roll_mobile_only does and what the client turned off on purpose.
  (function(){
    var bars=document.querySelectorAll('[data-kb-marquee]');
    if(!bars.length) return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var BASE_GAP=34;  // the resting gap; must match theme.css's var() fallback
    var SLACK=8;      // so subpixel rounding cannot expose a hairline of the repeat

    bars.forEach(function(bar){
      var track=bar.querySelector('.trustbar__track');
      if(!track) return;
      var speed=(+bar.getAttribute('data-speed'))||55;

      function measure(){
        // The CSS drops the animation at some widths (roll_mobile_only above 600px).
        // Where it has, the row is a static centred one that wraps, and neither a
        // stretched gap nor a duration means anything there: hand both back to the
        // stylesheet rather than leaving a 191px gap on a row that is not moving.
        if(getComputedStyle(track).animationName==='none'){
          bar.style.removeProperty('--roll-gap');
          bar.style.removeProperty('--roll-duration');
          return;
        }
        var items=track.children, n=items.length, sum=0, widest=0, i, w;
        if(!n) return;
        // Item widths do not depend on the gap, so this total is stable to measure
        // before the gap is written back.
        for(i=0;i<n;i++){ w=items[i].getBoundingClientRect().width; sum+=w; if(w>widest) widest=w; }
        // ⚠️ Clearing the viewport is NOT sufficient, and a first cut of this that
        // only cleared it was measured failing at 1920: with one pass exactly a
        // screen wide, the copy sliding out on the left and its twin sliding in on
        // the right are both in frame as slivers, which is still the same trust
        // point on screen twice. The twin's left edge must not reach the screen
        // until the original's right edge has left it, and the gap between those
        // two events is one item wide. Hence + widest: solve
        //   track >= viewport + widest   for   track = sum + n*gap.
        // The widest item governs, not the average, because any item may be the one
        // straddling the edge.
        var need=Math.ceil((bar.clientWidth+widest+SLACK-sum)/n);
        bar.style.setProperty('--roll-gap', Math.max(BASE_GAP,need)+'px');
        // Reading scrollWidth forces the reflow, so this already reflects the gap
        // just written; the duration has to be derived from the stretched width or
        // a wide screen would scroll at the wrong speed.
        var w=track.scrollWidth;
        if(w) bar.style.setProperty('--roll-duration', (w/speed)+'s');
      }
      measure();

      var resizeTimer=null;
      function remeasureSoon(){
        clearTimeout(resizeTimer);
        resizeTimer=setTimeout(measure,150);
      }
      // A window resize event is not a reliable signal that THIS element changed
      // width: it misses a scrollbar appearing, a zoom change, and any layout shift
      // that resizes the bar without resizing the window. Observed live while
      // testing, where one viewport change left a stale 95px gap on a 1920 screen
      // and the strip kept showing the duplicate. ResizeObserver watches the box
      // that actually matters; the window listener stays as the fallback.
      if(window.ResizeObserver){ new ResizeObserver(remeasureSoon).observe(bar); }
      window.addEventListener('resize',remeasureSoon);
      // A web font swapping in after first paint changes the text (and so the
      // track) width; remeasure once it lands, or the loop desyncs from the copy.
      if(document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

      var pause=bar.querySelector('.trustbar__pause');
      if(!pause) return;
      pause.addEventListener('click',function(){
        bar.classList.toggle('is-paused');
      });
    });
  })();

})();
